import React, { useEffect, useState } from 'react'
import useDoctorsStore from 'modules/doctors_dashboard/store'
import InputDate from 'modules/doctors_dashboard/InputDate';
import DoctorsTable from 'modules/doctors_dashboard/DoctorsTable';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import {
    getFormattedStartDate,
    getFormattedEndDate,
    revenueRepStartDate,
    revenueRepEndDate,
  } from "functionCall";

function DoctorsTab() {
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const {doctorsData, doctorsLoading, fetchDoctorsData}=useDoctorsStore();
    const [defaultStart, setDefaultStart]= useState(encodeURIComponent(revenueRepStartDate(getFormattedEndDate(1))));
    const [defaultEnd, setDefaultEnd]= useState(encodeURIComponent(revenueRepStartDate(getFormattedStartDate())))
    const startDate=searchParams.get("startDate");
    const endDate=searchParams.get("endDate")
    const [startFilterDate, setStartFilterDate]= useState();
    const [endFilterDate, setEndFilterDate]= useState();     
    const [clear, setClear]= useState(false);
    const [firstCall, setFirstCall] = useState(0);
    
    useEffect(()=>{
        if(startFilterDate&&endFilterDate){
            let encodeStartDate= encodeURIComponent(revenueRepStartDate(startFilterDate))
            let encodeEndDate=encodeURIComponent(revenueRepEndDate(endFilterDate))
            fetchDoctorsData(encodeStartDate, encodeEndDate);
            const url = `/home?startDate=${encodeStartDate}&endDate=${encodeEndDate}`;
            navigate(url);
        }
        else{
          if(startDate && endDate){
            fetchDoctorsData(startDate, endDate);
          }
        }
        if(clear){
            fetchDoctorsData(defaultStart, defaultEnd);
            const url = `/home?startDate=${defaultStart}&endDate=${defaultEnd}`;
            navigate(url);

        }
    },[startFilterDate, endFilterDate, startDate, endDate,clear])


  return (
    <div className='d-flex flex-column'>
        <div className='align-self-end mt-3'>
        <InputDate setStartFilterDate={setStartFilterDate} setEndFilterDate={setEndFilterDate} setClear={setClear}/>
        </div>
        <div className='mt-3'>
        <DoctorsTable doctorsData={doctorsData} doctorsLoading={doctorsLoading}/>
        </div>
      
    </div>
  )
}

export default DoctorsTab;